import Vue from "vue";
import Moment from "vue-moment";

export default {
  formatPhone(phone) {
    if (phone) {
      //Check if the input is of correct
      let match = phone.match(/^(\d{3})?(\d{2})(\d{4})(\d{4})$/);

      if (match) {
        //Remove the matched extension code
        //Change this to format for any country code.
        let intlCode = match[1] ? "+1 " : "";
        return [
          "+",
          match[1],
          " ",
          match[2],
          " ",
          match[3],
          "-",
          match[4]
        ].join("");
      }
    }
  },
  formatPrice(price) {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 2,
      useGrouping: true
    }).format(price);
  },
  formatExcelPrice(price) {
    let p = 0;
    if (price) p = price.toFixed(2);
    return `${p.toString().replace(".", ",")}`;
  },
  //toma los últimos 4 digitos y devuelve el formato xxxx xxxx xxxx 2389
  formatExportLastFourDigits(lastFourDigits) {
    return `XXXX XXXX XXXX ${lastFourDigits.trim()}`;
  },
  formatExportExpDate(expDate) {
    return Vue.prototype.$moment(expDate).format("MM/YY");
  },
  copyToClipboard(str) {
    const el = document.createElement("textarea"); // Create a <textarea> element
    el.value = str; // Set its value to the string that you want copied
    el.setAttribute("readonly", ""); // Make it readonly to be tamper-proof
    el.style.position = "absolute";
    el.style.left = "-9999px"; // Move outside the screen to make it invisible
    document.body.appendChild(el); // Append the <textarea> element to the HTML document
    const selected =
      document.getSelection().rangeCount > 0 // Check if there is any content selected previously
        ? document.getSelection().getRangeAt(0) // Store selection if found
        : false; // Mark as false to know no selection existed before
    el.select(); // Select the <textarea> content
    document.execCommand("copy"); // Copy - only works as a result of a user action (e.g. click events)
    document.body.removeChild(el); // Remove the <textarea> element
    if (selected) {
      // If a selection existed before copying
      document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
      document.getSelection().addRange(selected); // Restore the original selection
    }
  },
  formatCardNumber(e, key) {
    var input = e.target.value;
    var result = input.replace(/\D/g, ""); //non numeric caracters
    result = result.split(" ").join(""); //remove spaces
    result = this.addSpaces(result);
    return result;
  },
  addSpaces(str) {
    var result = "";
    for (var x = 0; x < str.length; x++) {
      result += str.slice(x, x + 1);
      if ((x + 1) % 4 == 0) result += " ";
    }
    return result.trim();
  },
  validateCardNumber(rule, val, callback) {
    if (val) {
      var number = val.split(" ").join("");
      if (number.length < 14 || number.length > 19)
        callback("El número de la tarjeta debe tener entre 14 y 19 dígitos");
      else {
        callback();
      }
    } else callback();
  },
  formatExpDate(e, expDateKey) {
    var val = e.target.value.trim();
    if (/(0[1-9]|10|11|12)\/[0-9]{2}$/.test(val))
      //if format correct return
      return val;
    if (/(0[1-9]|10|11|12)\/20[0-9]{2}$/.test(val))
      //if autocomplete or paste sets MM/YYYY then transform to MM/YY
      return val.slice(0, 2) + "/" + val.slice(5, 7);
    else {
      if (val.length > 5)
        //if too long remove extra chars
        val = val.slice(0, 5);
      else {
        var plainVal = val.split("/").join(""); // remover barras
        if (!isNaN(plainVal) && plainVal.length > 2)
          val = plainVal.slice(0, 2) + "/" + plainVal.slice(2);
      }
    }
    return val;
  },
  /*
  validateExpDate(rule, val, callback) {
    if (val) {
      if (!/(0[1-9]|10|11|12)\/[0-9]{2}$/.test(val))
        callback(
          "Ingrese 2 dígitos indicando el mes y 2 dígitos indicando el año"
        );
      if (val.length < 2)
        callback(
          "Ingrese 2 dígitos indicando el mes y 2 dígitos indicando el año"
        );
      else if (parseInt(val.substring(0, 2)) > 12)
        callback("El mes no puede ser superior a 12.");
      else if (val.length == 5) {
        // creamos una fecha con formato año, mes, dia
        const expDate = new Date(
          parseInt(`20${val.substring(3, 5)}`),
          parseInt(val.substring(0, 2)) - 1,
          1
        );
        const currentDate = new Date();
        if (expDate < currentDate) callback("La fecha esta expirada.");
      }
      callback();
    } else callback();
  },
  */
  formatCVC(e, CVCKey) {
    //el string del input. Si no es un numero remover el caracter del input con slice
    //sino dejar el valor de todo el input
    var val = e.target.value;
    //if (isNaN(CVCKey)) val = e.target.value.slice(0, -1);
    if (val.length > 4) val = val.slice(0, 4);
    return val;
  },
  getTelCountryCodes() {
    const telCountryCodes = [
      { label: "🇵🇪 +51", value: "+51" },
      { label: "🇲🇽 +52", value: "+52" },
      { label: "🇨🇺 +53", value: "+53" },
      { label: "🇦🇷 +549", value: "+549" },
      { label: "🇧🇷 +55", value: "+55" },
      { label: "🇨🇱 +56", value: "+56" },
      { label: "🇨🇴 +57", value: "+57" },
      { label: "🇻🇪 +58", value: "+58" },
      { label: "🇬🇹 +502", value: "+502" },
      { label: "🇸🇻 +503", value: "+503" },
      { label: "🇭🇳 +504", value: "+504" },
      { label: "🇳🇮 +505", value: "+505" },
      { label: "🇨🇷 +506", value: "+506" },
      { label: "🇵🇦 +507", value: "+507" },
      { label: "🇭🇹 +509", value: "+509" },
      { label: "🇧🇴 +591", value: "+591" },
      { label: "🇪🇨 +593", value: "+593" },
      { label: "🇵🇾 +595", value: "+595" },
      { label: "🇺🇾 +598", value: "+598" },
      { label: "🇩🇴 +809", value: "+809" },
      { label: "🇯🇲 +876", value: "+876" },
      { label: "🇵🇷 +1787", value: "+1787" }
    ];
    return telCountryCodes;
  },
  getPrefix(tel) {
    let prefix, phone;
    //todos los codigos de pais comenzando en 50 o 59 son de 3 digitos. En argentina también se asume el prefijo con el 9 de celular.
    if (
      tel.substring(1, 4) === "549" ||
      tel.substring(1, 3) === "50" ||
      tel.substring(1, 3) === "59" ||
      tel.substring(1, 4) === "809" ||
      tel.substring(1, 4) === "876"
    ) {
      prefix = tel.substring(0, 4); //primeros 3 digitos despues del '+' ej: 509
      phone = tel.substring(4); //ej: resto del tel sacando los primeros 3 digitos y el '+'
    } else if (tel.substring(0, 5) === "1787") {
      prefix = tel.substring(0, 5); //primeros 4 digitos despues del '+' ej: 1787
      phone = tel.substring(5); //ej: resto del tel sacando los primeros 4 digitos y el '+'
    } else {
      prefix = tel.substring(0, 3); //primeros 2 digitos despues del '+' ej: 51
      phone = tel.substring(3); //ej: resto del tel sacando los primeros 3 digitos y el '+'
    }
    return {
      prefix,
      phone
    };
  },
  capitalize(text) {
    let textLower = text.toLowerCase();
    return textLower.charAt(0).toUpperCase() + textLower.slice(1);
  }
};
